import React from 'react';

import { ButtonSizes } from '@Components/Buttons/Button';
import ButtonLink from '@Components/Buttons/ButtonLink';
import Row from '@Components/layout/Row';
import Typography from '@Components/Typography';
import { RouteConfig } from '@Config/routes';
import { useTranslations } from '@Hooks/useTranslations';
import { MessageKeysWithoutParams } from '@Utils/translation';

import styles from './NoResultsContainerStyles.module.scss';

interface NoResultsContainerProps {
  message?: MessageKeysWithoutParams;
  buttonLink?: string;
  buttonMsg?: MessageKeysWithoutParams;
  displayActionButton: boolean;
}

const NoResultsContainer: React.FC<NoResultsContainerProps> = ({
  message = 'msg_label_no_results',
  buttonLink = RouteConfig.Marketplace.buildLink(),
  buttonMsg = 'msg_btn_company_orders_go_to_marketplace',
  displayActionButton,
}) => {
  const t = useTranslations();

  return (
    <Row column alignCenter>
      <Typography tag="h3" msg={t(message)} className={styles.message} />
      {displayActionButton && (
        <ButtonLink link={buttonLink} size={ButtonSizes.s}>
          <Typography tag="span" msg={t(buttonMsg)} />
        </ButtonLink>
      )}
    </Row>
  );
};

export default NoResultsContainer;
